import '../scss/style.scss';

// import 'browsernizr/test/css/rgba';
import 'browsernizr/test/file/filesystem';
import 'browsernizr/test/websockets';
import svg4everybody from 'svg4everybody/dist/svg4everybody';


/*Site wiegets*/

// import ComponentExample from './blocks/block_example.js';
import BlockHero from './blocks/block_hero.js';
// console.log('ComponentExample', ComponentExample)
/*Modernizr*/

import Modernizr from 'browsernizr';
import LatestVideos from './blocks/latest_videos';
import SnipetWithImage from './blocks/snipet_with_image';
import ImageGridWithCaption from './blocks/image_grid_with_caption';
import TitleGridWithCaption from './blocks/title_grid_with_caption';
import FAQs from './blocks/faqs';
import LatestNews from './blocks/latest_news';
import TestimonialSlider from './blocks/testimonial_slider';
import TestimonialSliderUnique from './blocks/testimonial_slider_unique'; 
import Stats from './blocks/stats';
import ReusableContentOurProgrammes from './blocks/reusable_content_our_programmes';
import ParagraphWithImage from './blocks/paragraph_with_image';
import People from './blocks/people';
import Menu from './menu';
import DonateModal from './donate-modal';
import Testimonies from './blocks/testimonies';
import GlobalTracking from './helpers/globalTracking'

// Set global variables
window.WINDOW_WIDTH = $(window).width();
window.WINDOW_HEIGHT = $(window).height();
window.BREAK_XL = 1200;
window.BREAK_LG = 992;
window.BREAK_MD = 768;
window.BREAK_SM = 576;
window.BREAK_XS = 480;

$(document).ready(function() {

	// Lets get the SVGs in:
	svg4everybody();

	// Only initialise the class if the widget exists on the page.
	let blockHeroExample;
	let blockLatestVideos;
	let blockSnipetWithImage;
	let blockImageGridWithCaption;
	let blockTitleGridWithCaption;
	let blockFAQs;
	let blockLatestNews;
	let blockTestimonialSlider;
	let blockTestimonialSliderUnique;
	let blockStats;
	let blockPeople;
	let reusableOurProgrammes;
	let paragraphWithImage;
	let testimonies;

	// Initialise global tracking
	window.GlobalTracking = new GlobalTracking($('body'))

	// Initialise the menu
	let menu = new Menu($('.header'))
	let donateModal = new DonateModal($('.donateModal'))

	$('.js-share-twitter-link').click(function(e) {
		e.preventDefault();
		var href = $(this).attr('href');
		window.open(href, "Twitter", "height=285,width=550,resizable=1");
		// console.log(href)
	  });

	  $('.js-share-facebook-link').click(function(e) {
		e.preventDefault();
		var href = $(this).attr('href');
		window.open(href, "Facebook", "height=269,width=550,resizable=1");
		// console.log(href)
	  });

	  $('body').find('.block_wrapper').each(function(index){
		if($(this).hasClass('hero')){

			blockHeroExample = new BlockHero($(this));
			
			blockHeroExample.publicBlockHero("defined");
			
		}
	  })
	
	$('body').find('.block').each(function(index){

		

		if($(this).hasClass('block_latest_videos')){

			blockLatestVideos = new LatestVideos($(this));
			
			
		}

		if($(this).hasClass('block_snipet_with_image')){

			blockSnipetWithImage = new SnipetWithImage($(this));
			
			
		}

		if($(this).hasClass('block_image_grid_with_caption')){

			blockImageGridWithCaption = new ImageGridWithCaption($(this));
			
			
		}

		if($(this).hasClass('block_title_grid_with_caption')){

			blockTitleGridWithCaption = new TitleGridWithCaption($(this));
			
			
		}

		if($(this).hasClass('block_faqs')){

			blockFAQs = new FAQs($(this));
			
			
		}

		if($(this).hasClass('block_latest_news')){

			blockLatestNews = new LatestNews($(this));
			
			
		}

		if($(this).hasClass('block_testimonial_slider')){

			blockTestimonialSlider = new TestimonialSlider($(this));
			
			
		}

		if($(this).hasClass('block_testimonial_slider_unique')){

			blockTestimonialSliderUnique = new TestimonialSliderUnique($(this));
			
			
		}

		if($(this).hasClass('block_stats')){

			blockStats = new Stats($(this));
			
			
		}

		if($(this).hasClass('block_people')){

			blockPeople = new People($(this));
			
		}


		if($(this).hasClass('reusable-content-our-programmes')){

			reusableOurProgrammes = new ReusableContentOurProgrammes($(this));
			
			
		}

		if($(this).hasClass('block_paragraph_with_image')){

			paragraphWithImage = new ParagraphWithImage($(this));
						
		}

		if($(this).hasClass('block_testimonies')){

			testimonies = new Testimonies($(this));
						
		}
		
	})
});